
import './../../../App.css';

export default function Request_4(){
    return(
        <div className='form-header'>
            <ul>
                <li style={{backgroundColor:'#f9e0d0'}}>도면설계 - RPP 방음벽 (파이프 타입)</li>
            </ul>
            <ul>
                <li>구분</li>
                <li>내용</li>
            </ul>
            <ul>
                <li>납기일</li>
                <li>
                    <label>
                        <input
                            type="date"
                            name="r4_납기일"
                            required
                        />
                    </label>
                </li>
            </ul>
            <ul>
                <li>특이사항</li>
                <li>
                    <label>
                        <textarea
                            name="r4_특이사항"
                            rows="10"
                            placeholder="특이사항을 입력해주세요"
                            style={{
                                width: '100%',
                                resize: 'vertical',
                                fontSize: '16px',
                                border: 'none',
                                fontFamily: 'Noto Sans KR, sans-serif'
                            }}
                        />
                    </label>
                </li>
            </ul>
            <input type="hidden" name="r4_구조물종류" value="RPP 방음벽 (파이프 타입)" />
        </div>
    )
}
